import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ECheckPhoneStatus, isPhoneRegistered } from '../../api/isPhoneRegistered';
import { actionGenerator } from '../../types/redux/actionGenerator';
import { ECheckPhoneActionTypes } from './types';
import { EActiveView } from '../../types/view';
import { EActiveFlow } from '../../types/flow';
import { EEventType } from '../../types/events';
import { changeFlow } from '../flow';
import { changeView } from '../view';
import { sendCode } from './sendCode';
export var checkPhoneLoading = actionGenerator(ECheckPhoneActionTypes.Loading);
export var checkPhoneFailed = actionGenerator(ECheckPhoneActionTypes.Failed);
export var checkPhoneSucceed = actionGenerator(ECheckPhoneActionTypes.Succeed);
export function checkPhone() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, phone, view, response, isRegistered;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(checkPhoneLoading());
              _getState = getState(), phone = _getState.phoneAuth.phone, view = _getState.view;
              _context.next = 4;
              return isPhoneRegistered(context, {
                phone: phone
              });

            case 4:
              response = _context.sent;

              if (!(response.status === ECheckPhoneStatus.Succeed)) {
                _context.next = 11;
                break;
              }

              isRegistered = response.isRegistered;
              dispatch(checkPhoneSucceed({
                isRegistered: isRegistered
              }));
              context.emitter.emit(EEventType.PhoneChecked, {
                isRegistered: isRegistered
              });

              if (isRegistered) {
                dispatch(sendCode());
              } else {
                dispatch(changeView(EActiveView.Agreement, {
                  prevView: view.active,
                  prevData: view.data
                }));
                dispatch(changeFlow(EActiveFlow.Registration));
              }

              return _context.abrupt("return");

            case 11:
              dispatch(checkPhoneFailed(response.message));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}